import { render, staticRenderFns } from "./Undo.vue?vue&type=template&id=83b10696&scoped=true&"
import script from "./Undo.vue?vue&type=script&lang=ts&"
export * from "./Undo.vue?vue&type=script&lang=ts&"
import style0 from "./Undo.vue?vue&type=style&index=0&id=83b10696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b10696",
  null
  
)

export default component.exports